import { TRANSACTIONS_HISTORY } from '../../constants/actions'

const getTransactions = (offset, loading, loadingTx) => ({
  type: TRANSACTIONS_HISTORY.ON_GET_TRANSACTIONS,
  payload: { offset, loading, loadingTx }
})

const resetTransactionsState = () => ({
  type: TRANSACTIONS_HISTORY.RESET_STATE
})

export { getTransactions, resetTransactionsState }
